import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";


export const getProducts = async (id) => {
  try {
    return await getData(`/website/products/product`);
  } catch (error) {
    console.log(error);
  }
};